export default "__VITE_ASSET__9ab2c1ba__"